import React from 'react';

const useGoogleTranslate = () => {
    return React.useCallback((node) => {
        if (!node) return;
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                { pageLanguage: 'en', layout: window.google.translate.TranslateElement.InlineLayout.INLINE },
                'google_translate_element'
            );
        };
        const script = document.createElement('script');
        script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        script.async = true;
        document.body.appendChild(script);
    }, []);
};

export default useGoogleTranslate;
